// extracted by mini-css-extract-plugin
export var fullWidthButton = "_if-0";